export const title = "Pro Defense-V"
export const description = "¡LLEGAN LOS PREBIÓTICOS* A TU ZONA V PARA PROTEGERLA, manteniendo un pH saludable y en equilibrio"
